<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati predelovalcev</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezoneBranje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <div class="columnBar">
        Skriti stolpci:
              <kendo-multiselect 
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
        </div>
          <div class="grid-wrapper">
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                     
                         :pageable="{ buttonCount: 4, pageSizes: [10,50,100,'all'] }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        
                       
                        @pagechange="pageChangeHandler"
                       
                        
                                              

                         
                        
                                               >
                 
                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem.veljaven"/>
                    </template>
                    <template v-slot:certifikatLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" v-if="props.dataItem.id >= 0"
                        :href="'/interno/certifikatp/'+props.dataItem.id" target="_blank" title="Poglej">
                         <font-awesome-icon icon="certificate"/> &nbsp;
                         
                    </a>
                </td></template>
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                           <button 
                                title="Išči"
                                class="k-button k-primary"
                                @click="naloziPodatke"
                            >
                                Išči
                            </button>
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        </div>
                            
                        </toolbar>
                    </Grid>
                    <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                    </div>
                    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import CheckBoxGridItem from './support/CheckBoxGridItem';
Vue.component('kendo-multiselect', MultiSelect);


import { process } from '@progress/kendo-data-query';

 





export default {
  props:['sezona'],
   components:{
      'dropdownlist': DropDownList,
      'cbItem': CheckBoxGridItem,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
         
            dataSezona:this.sezona,
           loading:false,
         
            


            filter: {
                logic: "and",
                filters: [
                    { field: "veljaven", operator: "eq", value: 1 }
                 
                ]
            },
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],
         
            sort: [
                { field: 'datumizdaje', dir: 'asc' }
            ],
            
          

           

        }
    },
    created () {

      


            
      
      if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
    // this.loadVse({sezona:this.dataSezona.sezona});
 
    },
    computed: {
        columns() {
            var   columns= [
       
                { field: "stevilkacertifikata", filterable:false, title:"Številka certifikata",width: "170px",footerCell:this.nogaNazivVsot},
                { field: "kontrolnastevilka", title:"Kontrolna št.",width: "150px"},
                { field: "imenosilca", title:"Nosilec",width: "150px"},
                  { field: "datumizdaje", title:"Datum izdaje",width: "100px",filterable:false, type:"date",format:"{0:d}"},
                  { field: "datumveljavnosti", title:"Datum veljavnosti",width: "100px",filterable:false, type:"date",format:"{0:d}"},
                  { field: "veljaven", title:"Veljaven",width: "100px",cell:"cbItem",hidden:true},
                  { field: "certifikatLink", title:"Certifikat",width: "60",cell:"certifikatLink",filterable:false},
          
                
               
              
                //{ field: "kmgmid", title:"KMG-MID",width: "150px",footerCell: this.nogaStMidov},
                
                { field: "statuspredelovalca", title:"Status",width: "150px"},
                { field: "postnastevilka", title:"Poštna številka"},
                { field: "posta", title:"Pošta"},
                { field: "obcina", title:"Občina"},
                { field: "statisticnaregija", title:"Statistična regija"},
                
           
            ];
            if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});

            return columns;
       },
         hiddenColumns() {
            return this.columns.filter(c=>c.hidden);
        },
...mapState('users', ['userDetails','sezoneBranje']),
         ...mapState({gridData(state) {
      
          return state.certifikatPredelava.certifikatPredelava;
        }}),         
    
           },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gridData, dataState);
        },
       gridData(newValue, oldValue) {
  

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);

        }
    }
},
    methods: {
        shraniCertifikat: function(certifikat) {
            certifikat.jeaktivna=1;
            this.saveCert({certifikat:certifikat});
        },
        brisiCertifikat: function(certifikat) {
            certifikat.jeaktivna=0;
            this.saveCert({certifikat:certifikat});
        },
    naloziPodatke: async function(e){
            this.loading=true;
            if(!this.sezona){
                this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
                this.sezona=this.dataSezona.sezona;
            }
            else
                this.dataSezona={sezona:this.sezona};
        this.loadVse(this.dataSezona).then(()=>this.loading=false);
        },
        ...mapActions('certifikatPredelava', ['loadVse']),
        
skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
           
        },

        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Število:']);
        },
        nogaSteviloCertifikatova: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data)
            return h('span', {}, [kendo.toString(this.dataResult.data.length,"n0")]);
        },
       
        nogaStMidov: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                     counts[this.dataResult.data[i][props.field]] = 1 + (counts[this.dataResult.data[i][props.field]] || 0);
                }
                 return h('span', {}, [kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
        formatDate: function (h, emptyElement , props, listeners ) {
        
            return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
    

      
        sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;

            this.$router.push({ name: 'certifikatiPredelava', params: { sezona:sezona.sezona} })
            this.dataSezona=sezona;
           // this.loadVse(this.dataSezona);



        },

        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
         
            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
         

        },
      
        exportExcel () {
            this.saveExcel({
                data: this.dataResult.data,
                fileName: this.dataSezona.sezona+"_CERTIFIKATIPREDELAVA",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },
        
     
        pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

